// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./typography.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/loginbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lato {
  font-family: Lato !important;
}
.k2d {
  font-family: K2D !important;
}
.work {
  font-family: Work Sans !important;
}
.mulish {
  font-family: Mulish !important;
}
.poppins {
  font-family: Poppins;
}
.home {
  overflow-x: hidden !important;
}
.akira {
  font-family: Akira !important;
}
.clash {
  font-family: Clash !important;
}
.segoe {
  font-family: Segoe UI !important;
}
.sansation {
  font-family: Sansation;
}
.nunito {
  font-family: Nunito;
}
.krub {
  font-family: Krub !important;
}
p {
  padding-bottom: 0px !important;

  /* padding: 0px 0px 0px 0px !important; */
}
.textColor {
  background: linear-gradient(90deg, #0966ab 0%, #2f80ed 50%, #2d9ee0 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.btngradient {
  background: linear-gradient(90deg, #0966ab 0%, #2f80ed 50%, #2d9ee0 100%);
}
.textColor {
  background: linear-gradient(90deg, #082038 0%, #363795 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #ebf1ff;
  border-radius: 10px;
}
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}
::-webkit-scrollbar-thumb {
  background: #0d3e6f;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #9cd5ff;
  /* background: var(--color5); */
}
.myShadow {
  box-shadow: 0px 5px 12px 0px rgba(0, 0, 0, 0.25);
}
.myShadow2 {
  box-shadow: 0px 5px 12px 0px rgba(0, 0, 0, 0.15);
}
.noScroll::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.maingradient {
  background: linear-gradient(90deg, #0d3e6f 0%, #363795 100%);
}
.loginBg1 {
  background-image: linear-gradient(90deg, #0d3e6f 0%, #363795 100%),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

/* input:focus {

border: none !important;
} */

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #ebf1ff;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #e65c00;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #9cd5ff;
  /* background: var(--color5); */
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.swiper-pagination-bullet-active {
  background-color: #ff512f !important;
}
.style-module_simpleStarRating__nWUxf svg {
  display: inline !important;
  height: 25px !important;
  gap: 1rem;
}
@media only screen and (max-width: 767px) {
  .swiper-button-next,
  .swiper-button-prev {
    /* background-color: white; */
    display: none !important;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;;EAE9B,yCAAyC;AAC3C;AACA;EACE,yEAAyE;EACzE,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,4DAA4D;EAC5D,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,4DAA4D;AAC9D;AACA;EACE;2CAC6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;;GAGG;;AAEH;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;AACX;AACA;EACE;;IAEE,6BAA6B;IAC7B,wBAAwB;EAC1B;AACF;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@import url(\"typography.css\");\n\n.lato {\n  font-family: Lato !important;\n}\n.k2d {\n  font-family: K2D !important;\n}\n.work {\n  font-family: Work Sans !important;\n}\n.mulish {\n  font-family: Mulish !important;\n}\n.poppins {\n  font-family: Poppins;\n}\n.home {\n  overflow-x: hidden !important;\n}\n.akira {\n  font-family: Akira !important;\n}\n.clash {\n  font-family: Clash !important;\n}\n.segoe {\n  font-family: Segoe UI !important;\n}\n.sansation {\n  font-family: Sansation;\n}\n.nunito {\n  font-family: Nunito;\n}\n.krub {\n  font-family: Krub !important;\n}\np {\n  padding-bottom: 0px !important;\n\n  /* padding: 0px 0px 0px 0px !important; */\n}\n.textColor {\n  background: linear-gradient(90deg, #0966ab 0%, #2f80ed 50%, #2d9ee0 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.btngradient {\n  background: linear-gradient(90deg, #0966ab 0%, #2f80ed 50%, #2d9ee0 100%);\n}\n.textColor {\n  background: linear-gradient(90deg, #082038 0%, #363795 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px #ebf1ff;\n  border-radius: 10px;\n}\n::-webkit-scrollbar {\n  width: 8px;\n  height: 10px;\n}\n::-webkit-scrollbar-thumb {\n  background: #0d3e6f;\n  border-radius: 10px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #9cd5ff;\n  /* background: var(--color5); */\n}\n.myShadow {\n  box-shadow: 0px 5px 12px 0px rgba(0, 0, 0, 0.25);\n}\n.myShadow2 {\n  box-shadow: 0px 5px 12px 0px rgba(0, 0, 0, 0.15);\n}\n.noScroll::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n}\n.maingradient {\n  background: linear-gradient(90deg, #0d3e6f 0%, #363795 100%);\n}\n.loginBg1 {\n  background-image: linear-gradient(90deg, #0d3e6f 0%, #363795 100%),\n    url(\"./assets/loginbg.png\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n\n/* input:focus {\n\nborder: none !important;\n} */\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px #ebf1ff;\n  border-radius: 10px;\n}\n::-webkit-scrollbar-thumb {\n  background: #e65c00;\n  border-radius: 10px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #9cd5ff;\n  /* background: var(--color5); */\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n.swiper-pagination-bullet-active {\n  background-color: #ff512f !important;\n}\n.style-module_simpleStarRating__nWUxf svg {\n  display: inline !important;\n  height: 25px !important;\n  gap: 1rem;\n}\n@media only screen and (max-width: 767px) {\n  .swiper-button-next,\n  .swiper-button-prev {\n    /* background-color: white; */\n    display: none !important;\n  }\n}\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
